import type { FaireProductEntity } from "../../entity_types/product";

export const p_w86msmp6fg: FaireProductEntity = {
  token: "p_w86msmp6fg",
  type: "product",
  name: "PRICKLY PEAR Medium Candle",
  brandToken: "b_efy227uud9",
  brandName: "CICADA",
  imageUrl:
    "https://cdn.faire.com/fastly/0d4137c1128f0a0a2d06a132c722ff784b2b7b801a9dbeb59024647b853f5dfc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/19656452e55236265e5345999018d6d7b1683d84c81f2a68f375805b3c01ff2a.jpeg",
    "https://cdn.faire.com/fastly/8b9b09c9804767478041f46b71877d11bf4e6b43dcf9b0beb6b6cdbdae1c646f.jpeg",
    "https://cdn.faire.com/fastly/3b055df2d7d1ea939f41529c9ad912d715c6c5ce6b5968116d17d632b5370915.jpeg",
  ],
  priceDollars: 15,
  description:
    "(previously called scent No. 09)\n\nThe scent of desert harvests. Lips and fingers stained with ripe cactus fruit. How lucky am I? Don’t forget to remember.\n\nNOTES\nprickly pear + desert spice + crushed citrus + cactus sap\n\nBURN TIME\n45-50 hours. This single wicked candle has great hot throw and is perfect for lsmaller spaces.\n\n9 ounce / 113 g in glass jar candle in gift box with UPC located on bottom of box\n\nMADE BETTER\n• signature coconut-soy blend wax\n• infused with natural essential oils and phthalate-free fine fragrance\n• cotton core-less wicks (no metals!)\n• cruelty-free\n• paraben-free\n• dye-free\n• eco-friendly\n• reusable glass vessel",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:06.685Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
